// extracted by mini-css-extract-plugin
module.exports = {"price":"_93444fe79c--price--3xngq","value":"_93444fe79c--value--3hCXI","currency":"_93444fe79c--currency--2_ZTG"};